import React, { useState, useEffect, useContext } from 'react';
import {useMediaQuery} from "react-responsive";
import {IProps} from './types';
import Filter from './components/Filter';
import Chips from '@components/Chips';
import Order from './components/Order';
import List from './components/List';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import actions from '@state/actions';
import { reloadListAction } from '@state/openReducers/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import { useHistory } from 'react-router';
import { getOEMName } from 'utils/editor';
import FullPreview from '@routes/private/Studio/components/FullPreview';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import GridIcon from '@assets/icons/gridIcon';
import ListIcon from '@assets/icons/listIcon';
import { cloneDeep } from 'lodash';
import { ITemplate, IFileTemplate, } from '@state/templates/types';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';
import MoreChips from '@routes/private/Templates/components/ListTemplate/components/MoreChips';

const EDIT_DESCRIPTION = "Are you sure you want to edit these templates?\n\nAll status and tags will be overwritten."

const ListUserAccess:React.FC<IProps> = (props) => {
    const{ searching, showList, location, hasDesigns, isLookingForDesigns, value, setDeleteId, setFiltering, filtering, move, setSortByText } = useContext(UserAccessContext);    
    const studioContext = useContext(StudioContext);
    const authContext = useContext(AuthContext);
    const dispatch = useDispatch();
    const history: any = useHistory()
    const [filters, setFilters]= useState({oem:[], platform:[], format:[], offerType:[], templateStatus:[]} as any);
    const [allFilters, setAllf]=useState([] as any);
    const [activeFilter, setActivef]=useState(false);
    const [orderBy, setOrderBy]=useState("");    
    const [deteleItem, setDeteleItem] = useState([] as any);
    const [deleted, setDeleted]=useState(false);
    const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
    const [gridView, setGridView]=useState(false);

    const openMenu = useSelector(selectors.open.getOpenMenu);
    const userprofiles = useSelector(selectors.userAccess.getUserAccess);
    //const newTemplate = useSelector(selectors.open.getOpenTemplate);
    const reloadList = useSelector(selectors.open.getReloadList);

    const smallDesktopScreen = useMediaQuery({ query: '(max-width: 1300px)' });
    const mediumDesktopScreen = useMediaQuery({ query: '(max-width: 1450px)' });
    const [openEdit, setOpenEdit] = useState(false);
    const [files, setFiles] = useState<IFileTemplate[]>([]);
    const [isSaving, setIsSaving] = useState(false);
    const [savedItems, setSavedItems] = useState<ITemplate[]>([]);


    useEffect(() => {
      if(props.initialfilters){
        setFilters(props.initialfilters);
        setAllf([props.initialfilters?.platform[0] ?? props.initialfilters?.oem[0] ?? '']);
        setActivef(true);
      }
  }, [props.initialfilters]);

    /*useEffect(() => {
        if((!newTemplate)&&(reloadList)){
            setActivef(false);
            setAllf([]);
            setOrderBy("");
            setSortByText("");
            setFilters({oem:[], platform:[], format:[], offerType:[], templateStatus:[]} as any);
            dispatch(reloadListAction(false));
        }
    }, [templates]);*/

    const handleChageFilter=(value:any, type:string, add:boolean)=>{
        let typeFilters=filters[type]
        if(add){
            typeFilters.push(value);
            setAllf([...allFilters, value]);
        }
        else {
            typeFilters=typeFilters.filter((item:any) => item !== value)
            setAllf(allFilters.filter((item:any) => item !== value));
        }
        
        setFilters({...filters, [type]: typeFilters});
        setActivef(true);
    }

    const handleRemoveChip = (index: number) => {
        let value= allFilters[index];
        let newFilters = allFilters.filter((val:any,idx:number) => index !== idx);
        setAllf(newFilters);

        var type = Object.keys(filters).find(k=>filters[k].includes(value));
        if(type){
            let newList=filters[type].filter((item:any) => item !== value)
            setFilters({...filters, [type]: newList});
        }

        if(location==='studio' && newFilters.length===0 )setFiltering(false);
    }
    const handleRemoveAllChip = () => {
        setAllf([] as any);
        setFilters({oem:[], platform:[],format:[], offerType:[], templateStatus:[]} as any)
        if(location==='studio')setFiltering(false);
    }

    const handleClickOrderby=(query:string)=>setOrderBy(query);

    const countChips=()=>{
        let nchips=4;
        if(!openMenu)nchips=2;
        if(smallDesktopScreen){
            if(openMenu)nchips=2;
            else nchips=0;
        }
        else if(mediumDesktopScreen){
            if(openMenu)nchips=3;
            else nchips=1;
        }
        return nchips;
    }

    const nchips=countChips();
    
    const handleActionsTemplate= (action: string, items: ITemplate[], idx: number)=> {
        if(action==='DELETE')handleDeleteModal(items, idx)
        if(action==='EDIT') handleEditModal(items);
        if(action==='DUPLICATE') handleDuplicate(items);
    }

    const duplicateTemplate = (id: string) => {
      return new Promise((resolve, reject) => {
        const userData = {
          email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
          name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        dispatch(actions.templates.duplicateTemplate({id: id,userData: userData}, (result: any, error: any) => {
          if (error) {
            reject(error);
            setIsSaving(false);
          }
          else {
            resolve(result);
          }
        }))
      })
    }
  
    const handleDuplicate = async (templates: ITemplate[]) => {
      try {
        setIsSaving(true);
        dispatch(reloadListAction(false));
        const templateDuplicated = await duplicateTemplate(templates[0].id);
        history.push({pathname: '/templates'});
        dispatch(reloadListAction(true));
        setIsSaving(false);
      } catch (error) {
        props.handleWarningScreen(
          true, "Duplicate Template",
          `The template was not duplicated, please try later..`,
          "", undefined, "OKAY", "Duplicate template process failure",[]
        );
      }
    }

    const handleEditModal = (items: ITemplate[]) => {
      var newFiles: IFileTemplate[] = [];
      items.map(item => {
        const template = {
          ...item,
          file: { name: item.name }
        };
        setOpenEdit(true);
        template.file = {name: template.name};
        template.tags.oem = getOEMName(template.tags.oem, dsConfig);
        newFiles.push(template);
      });
      setFiles(newFiles);
      setIsSaving(false);
    }

    const handleDeleteModal = (items: ITemplate[], idx: number) => {
        setDeleted(false);        
        setDeteleItem([]);        
        props.handleWarningScreen(
            true, "Delete Template",
            `Are you sure you want to delete this template?\n\nThis action cannot be undone.\n\nNote: Disabling a template allows it's use in the future, deletion does not. \n\n`,
            "CANCEL", () => {handleDeleteTemplate(items[0], idx)}, "YES, DELETE", "", []
          );
    }


    const handleDeleteTemplate = async(item:any, idx: number) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };

        item.templateStatus="INACTIVE";
        item.updatedBy=userData;
        
        try {
            props.handleWarningScreen(
                true, "Delete Template",
                `Are you sure you want to delete this template?\n\nThis action cannot be undone.\n\nNote: Disabling a template allows it's use in the future, deletion does not. \n\n`,
                "", () => {return false;}, "DELETING...", "", []
              );
            const response: any = await saveTemplate(item);
            if(response){
                setDeteleItem([idx]);
                setDeleteId(item.id);
                props.handleWarningScreen(
                    true, "Delete Template",
                    `The template was deleted successfully.`,
                    "", () => {deleteItemList()}, "OKAY", "",[]
                );
            }
        } catch(e) {
            props.handleWarningScreen(
                true, "Delete Template",
                `The template was not delete, please try later..`,
                "", undefined, "OKAY", "Delete template process failure",[]
            );
        }
    }


    const handleDeleteAllModal = (templates:any, idx:number[]) => {
      setDeleted(false);      
      setDeteleItem([]);      
      props.handleWarningScreen(
          true, "Delete Templates",
          `Are you sure you want to delete these templates?\n\nThis action cannot be undone.\n\nNote: Disabling a template allows it's use in the future, deletion does not. \n\n`,
          "CANCEL", () => {handleDeleteTemplates(templates, idx)}, "YES, DELETE", "", []
        );
    }

    const handleDeleteTemplates = async (templates:any, idx:any)=>{

      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      } ;

      templates.map((item:any)=>{
        item.templateStatus="INACTIVE";
        item.updatedBy=userData;
      })

      try {
        props.handleWarningScreen(
            true, "Delete Templates",
            `Are you sure you want to delete these templates?\n\nThis action cannot be undone.\n\nNote: Disabling a template allows it's use in the future, deletion does not. \n\n`,
            "", () => {return false;}, "DELETING...", "", []
          );        
        const response: any = await saveTemplates(templates);              
        if(response){
            setDeteleItem(idx);
            ///setDeleteId(item.id);
            props.handleWarningScreen(
                true, "Delete Templates",
                `Templates were deleted successfully.`,
                "", () => {deleteItemList()}, "OKAY", "",[]
            );
        }
      } catch(e) {
          props.handleWarningScreen(
              true, "Delete Templates",
              `Templates were not deleted, please try later..`,
              "", undefined, "OKAY", "Delete templates process failure",[]
          );
      }


     
    }

    useEffect(() => {
        if(!props.openModal){          
          if((!deleted)&&(deteleItem.length>0))deleteItemList();
        }
    }, [props.openModal]);
    
    const deleteItemList = () => {
        setDeleted(true);
        props.handleWarningScreen(
            false, "","","", undefined, "", "",[]
        );
    }

    const handleFinishEditTemplates = async (templates: ITemplate[]) => {
      setIsSaving(true);
      if (templates.length >= 2) {
        props.handleWarningScreen(
          true, "Edit Templates",
          EDIT_DESCRIPTION,
          "CANCEL", () => {handleFinishEditTemplates(templates)}, "SAVING...", "", []
        );
      }
      try {
        const response: any = await saveTemplates(templates);
        if(response){          
          if (templates.length >= 2) {
            props.handleWarningScreen(false, "", "", "", undefined, "", "", []);
          }
          setIsSaving(false);
          setOpenEdit(false);
          setSavedItems(templates);
        }
      } catch(e) {
        props.handleWarningScreen(
          true, "Edit Template",
          `The template was not edited, please try later..`,
          "", undefined, "OKAY", "Edit template process failure",[]
        );
        setOpenEdit(false);
        setIsSaving(false);
      }
    }

    const handleEditTemplates = (templates: ITemplate[]) => {
      if (templates.length < 2) handleFinishEditTemplates(templates);
      else {
        props.handleWarningScreen(
          true, "Edit Templates",
          EDIT_DESCRIPTION,
          "CANCEL", () => {handleFinishEditTemplates(templates)}, "YES", "", []
        );
      }
    }

    const saveTemplate = (template: any) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.templates.updateTemplate(template, (result: any, error: any) => {
                if (error) {
                  reject(error);
                } else {
                  resolve(result);
                }
            }))
        })
    }

    const saveTemplates = (templates: any) => {
      return new Promise((resolve, reject) => {
          dispatch(actions.templates.updateTemplates(templates, (result: any, error: any) => {
              if (error) {
                reject(error);
              } else {
                resolve(result);
              }
          }))
      })
  }

      

    useEffect(() => {
      if (studioContext && !studioContext.searching && !studioContext.filtering) handleRemoveAllChip();
  }, [studioContext]);

    useEffect(() => {
        if (location=="studio" && props.onSearch) props.onSearch(searching);
    }, [searching]);

    useEffect(() => {
      if(location=="studio"){
        if(value!=='')handleRemoveAllChip();
      }
    }, [value]);
    
    useEffect(() => {
      if(activeFilter){
        if(allFilters.length>0)setFiltering(true);
        else setFiltering(false);
      }
    }, [allFilters]);
      
    const handleSearch = () =>setOrderBy("");
    let marginTop='82px';
    /*if (location==='studio') {
      marginTop=(hasDesigns || showList) ? '82px': '17px';
      
      if (!hasDesigns) marginTop = '17px';
      if (isLookingForDesigns) marginTop = '82px';
      if (searching) marginTop = '82px';
    }*/
    
    return (
      <>
        <S.Root>
          <S.Container>
            <S.Header>
                <S.Transition>
                  <Filter onChange={handleChageFilter} onSearchClick={handleSearch} filters={filters} openMenu={openMenu} deteleItem={deleted}/>                  
                    <S.ChipsCol>
                        <Chips items={allFilters.slice(0, nchips)} handleRemove={handleRemoveChip}/>
                    </S.ChipsCol>
                   {(allFilters.length>nchips) ? <MoreChips chips={allFilters.slice(nchips, allFilters.length)} handleRemove={handleRemoveChip} handleRemoveAlll={handleRemoveAllChip} nchips={nchips}/>:''}
                </S.Transition>            
                <S.ViewOrderContainer>                 
                  <Order onClick={handleClickOrderby}/>
                </S.ViewOrderContainer>            
            </S.Header>
              <List 
                  gridView={gridView}
                  filters={filters}
                  activeFilter={activeFilter}
                  orderBy={orderBy}
                  onActionsTemplate={(action, item, idx) => handleActionsTemplate(action, item, idx)}
                  deteleItem={deleted ? deteleItem: []}
                  editUser={props.editUser}
                  savedItems={savedItems}
                  handleWarningScreen={props.handleWarningScreen}
                  deleteTemplates={handleDeleteAllModal}
                />                          
          </S.Container>
        </S.Root>
        {
          openEdit &&
          <>Edit</>
        }       
      </>
    );
}

export default ListUserAccess